import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import styles from "./style.module.css";
import sectionStyles from "../sectionStyles.module.css";
import { IMAGES } from "../../static/assets/images";
import { TEXTS } from "../../static/texts";

const services = [
  {
    title: TEXTS.SERVICES_CUBAS_TITLE,
    content: TEXTS.SERVICES_CUBAS_FLAVOR,
    image: IMAGES.SERVICIOS_CUBAS,
    to: "./cubas-lagares",
  },
  {
    title: TEXTS.SERVICES_PIEZAS_TITLE,
    content: TEXTS.SERVICES_PIEZAS_FLAVOR,
    image: IMAGES.SERVICIOS_PIEZAS,
    to: "./piezas-especiales",
  },
  {
    title: TEXTS.SERVICES_BODEGAS_TITLE,
    content: TEXTS.SERVICES_BODEGAS_FLAVOR,
    image: IMAGES.SERVICIOS_BODEGAS,
    to: "./bodegas-vinificadoras",
  },
];

const firstSliderImages = [
  IMAGES.CLIENTE_1,
  IMAGES.CLIENTE_2,
  IMAGES.CLIENTE_4,
  IMAGES.CLIENTE_3,
  IMAGES.CLIENTE_5,
  IMAGES.CLIENTE_7,
  IMAGES.CLIENTE_8,
  IMAGES.CLIENTE_6,
  IMAGES.CLIENTE_9,
  IMAGES.CLIENTE_10,
  IMAGES.CLIENTE_11,
];

const secondSliderImages = [
  IMAGES.CLIENTE_12,
  IMAGES.CLIENTE_13,
  IMAGES.CLIENTE_14,
  IMAGES.CLIENTE_15,
  IMAGES.CLIENTE_16,
]

export const Home = () => {
  return (
    <>
      <div className={styles.bannerContainer}>
        <div className={styles.gradientBackground} />
        <div className={styles.titleContainer}>
          <h1 className={sectionStyles.titleText}>
            CONCRET<span className={styles.titleV}>V</span>S{`\n`}
            {TEXTS.HEADER_SUBTEXT_1}
          </h1>
        </div>
      </div>

      <div className={sectionStyles.redContainer}>
        <p className={sectionStyles.mediumText}>{TEXTS.HOME_FLAVOR_TEXT}</p>
      </div>

      <div className={sectionStyles.blackContainer}>
        <h3 className={sectionStyles.headerText}>
          {TEXTS.HOME_SERVICES_HEADER}
        </h3>
        <div className={styles.servicesWrapper}>
          {services.map((service, index) => (
            <>
              <Link
                key={`Home-link-${index}`}
                to={service.to}
                className={styles.serviceCard}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className={styles.serviceImage}
                />
                <div className={styles.cardTitleContainer}>
                  <h4 className={styles.cardTitle}>{service.title}</h4>
                </div>
                <p className={styles.cardContent}>{service.content}</p>
              </Link>
              {index < services.length - 1 && (
                <div className={styles.serviceSeparator} />
              )}
            </>
          ))}
        </div>
      </div>
      <div className={sectionStyles.redContainer}>
        <div className={styles.equipoContainer}>
          <h2 className={styles.equipoHeader}>{TEXTS.HOME_EQUIPO_HEADER}</h2>
          <Link to="/nosotros" className={styles.equipoButton}>
            {TEXTS.HOME_EQUIPO_BUTTON}
          </Link>
        </div>
      </div>
      <div className={styles.clientesContainer}>
        <h3 className={sectionStyles.largeText}>{TEXTS.HOME_CLIENTS_HEADER}</h3>
        <div className={styles.slider}>
          <Slider
            dots={false}
            infinite={true}
            slidesToShow={3}
            slidesToScroll={1}
            autoplay={true}
            speed={1000}
            autoplaySpeed={3000}
            cssEase="linear"
            draggable={true}
          >
            {firstSliderImages.map((imgSrc, index) => (
              <img
                key={`Cliente_${index}`}
                className={styles.sliderImage}
                src={imgSrc}
                alt={`Cliente ${index}`}
              />
            ))}
          </Slider>
        </div>
        <div className={styles.slider}>
          <Slider
            dots={false}
            infinite={true}
            slidesToShow={3}
            slidesToScroll={1}
            autoplay={true}
            speed={1000}
            autoplaySpeed={3000}
            cssEase="linear"
            rtl={true}
            draggable={true}
          >
            {secondSliderImages.map((imgSrc, index) => (
              <img
                key={`Cliente_${index}`}
                className={styles.sliderImage}
                src={imgSrc}
                alt={`Cliente ${index}`}
              />
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};
